exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container{width:1170px}.main-container{position:relative;min-height:calc(100vh - 140px)}.window-container{padding:60px;position:fixed;left:0;right:0;bottom:0;top:0;z-index:50;overflow:auto;background:rgba(0,0,0,.5)}.window{background:#fff;box-shadow:0 0 5px 0;border-radius:5px;position:relative}.window-title{border-radius:5px 5px 0 0;background:#222;color:#f6f6f6;padding:0 10px;height:40px;line-height:40px}.window-title-btn{height:40px;line-height:40px;cursor:pointer}.window-title-btn>i:first-child{color:#fff}.window-title-btn>i:last-child{color:#222;font-size:9pt}.window-title-btn:hover>i:first-child{color:#cf1928}.window-title-btn:hover>i:last-child{color:#e0d4d4;font-size:9pt}.window-action{border-radius:0 0 5px 5px;border-top:1px solid #ccc;padding:10px;background:#fff}[class*=fa-]:not(.fa-spin):not(.fa-pulse){animation:none}@media (max-width:995px)and (min-width:768px){.peopleSearch{display:none}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/stylesheets/layout.css
 ** module id = 2254
 ** module chunks = 73
 **/